/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { createIntl, createIntlCache } from 'react-intl';
import { useSelector } from 'react-redux';
import translations from '~/infra/i18n/locales';
import { getLocale } from '~/utils/getLocale';
import { Content, Container, ContentSignDoc } from './styles/StyledSignature';

import { Button, Select } from '~/presentation/components/UI';

import { translator } from '~/presentation/components/i18n';

import { MakeRemoteGetCertificates } from '~/main/factories/usecases/daemon/GetCertificates';
import { makeRemoteGetVidasCertificate } from '~/main/factories/usecases/vidas/GetVidasCertificateFactory';
import { GetCertificates } from '~/domain/usecases/deamon/remote';

import { V4hSpin } from '../spin';
import { iStore } from '~/domain/interfaces/models';
import { AlertMessage } from '../messages/AlertMessage';
import { getProfessionalInfo } from '~/utils/getProfessionalInfo';

const cache = createIntlCache();

const intl = createIntl(
  {
    locale: String(getLocale()),
    messages: translations[getLocale()],
  },
  cache,
);

export interface ownProps {
  changeSelected?: (data: any) => any;
  docId?: number;
  appointmentId?: number;
  changeDisabled?: (data: boolean) => any;
  onSignSubmit?: () => any;
  isSigned?: boolean;
}

interface iVidaasCertificate {
  slots?: {
    slot_alias?: string;
    label?: string;
  }[];
  status?: string;
}

const SignDoc: React.FC<ownProps> = ({
  changeSelected,
  docId,
  appointmentId,
  changeDisabled,
  onSignSubmit,
  isSigned,
}): JSX.Element => {
  const options = [
    { value: '1', label: 'Selecione seu assinador' },
    { value: '2', label: 'Ledger' },
    { value: '3', label: 'VIDaaS' },
  ];

  const [certificates, setCertifaces] = useState<GetCertificates.Model>([]);
  const [certificatesOptions, setCertificatesOptions] = useState(
    options[0].value,
  );
  const [vidaasCertificates, setVidaasCertificates] = useState(
    {} as iVidaasCertificate,
  );
  const [selected, setSelected] = useState<number>(-1);
  const [loadCertificate, setLoading] = useState<boolean>(false);
  const assign = useSelector((store: iStore) => store.clinicalDocs.loading);
  const [check, setCheck] = useState<boolean>(!!docId);
  const professional = getProfessionalInfo();

  useEffect(() => {
    if (professional?.id) {
      makeRemoteGetVidasCertificate()
        .get({
          professional: professional?.id,
        })
        .then(res => {
          setVidaasCertificates(res);
        })
        .catch(e => {
          console.log('error certificate', e);
        });
    }
  }, [professional]);

  useEffect(() => {
    setLoading(assign);
  }, [assign]);

  useEffect(() => {
    if (changeDisabled) {
      // * Se assinar agora estiver selecionado
      if (check) {
        // * Se um certificado estiver selecionado.
        if (selected !== -1) {
          changeDisabled(false);
        } else {
          changeDisabled(true);
        }
      } else {
        changeDisabled(false);
      }
    }
  }, [check, selected]);

  useEffect(() => {
    if (!isSigned) {
      setLoading(true);
      MakeRemoteGetCertificates()
        .getCertificates()
        .then(response => {
          console.log('ledger: ', response);
          setCertifaces(response);
          setLoading(false);
        })
        .catch(e => {
          AlertMessage({
            message: intl.formatMessage({
              id: 'Não foi possivel encontrar nenhum certificado',
            }),
            type: 'info',
          });
          setLoading(false);
        });
    }
  }, [isSigned]);

  const textButton = translator('Assinar Documento');

  return (
    <Container>
      <ContentSignDoc>
        <Content>
          <p>{`${translator('Certificado Digital')}`}</p>
          <Select
            label="Assinador"
            value={certificatesOptions}
            onChange={e => {
              setCertificatesOptions(e.target.value);
              setSelected(-1);
            }}
          >
            {options?.map(item => (
              <option value={item.value} key={item?.value}>
                {item.label}
              </option>
            ))}
          </Select>
          <Select
            label={`${translator('Certificado Digital')}`}
            value={selected}
            disabled={loadCertificate || certificatesOptions === '1'}
            onChange={e => {
              setSelected(Number(e.target.value));
              if (certificatesOptions === '3' && changeSelected) {
                changeSelected({
                  signatureSource: 'VIDAAS',
                });
              }
              if (certificatesOptions === '2') {
                if (changeSelected)
                  changeSelected({
                    certificateId: certificates[Number(e.target.value)].id,
                    certificate:
                      certificates[Number(e.target.value)].base64Certificate,
                  });
              }
            }}
          >
            <option value="-1" disabled>
              {`${translator('Selecione um certificado')}`}
            </option>
            {certificatesOptions === '2' && (
              <>
                {certificates.map((e, index) => (
                  <option value={index}>{e.name}</option>
                ))}
              </>
            )}
            {certificatesOptions === '3' && (
              <>
                {vidaasCertificates?.slots?.map((e, index) => (
                  <option value={index}>{e?.label}</option>
                ))}
              </>
            )}
          </Select>
        </Content>
        {!loadCertificate ? (
          <Button
            size="medium"
            rounded
            onClick={onSignSubmit}
            disabled={selected === -1}
          >
            {textButton}
          </Button>
        ) : (
          <V4hSpin fullScreen={false} size="40px" />
        )}
      </ContentSignDoc>
    </Container>
  );
};

export default SignDoc;
